import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import UserLayout from '../layouts/UserLayout';

const UserDashboard         = lazy(() => import('../pages/user/dashboard/Dashboard'));
const UserAccounts          = lazy(() => import('../pages/user/accounts/Accounts'));
const UserCourses           = lazy(() => import('../pages/user/course/Courses'));
const MyCourses             = lazy(() => import('../pages/user/course/MyCourses'));
const AllCourses            = lazy(() => import('../pages/user/course/AllCourses'));
const CourseDetails         = lazy(() => import('../website/CourseDetails'));
const CourseWatch           = lazy(() => import('../pages/user/course/CourseWatch/CourseWatch'));
const OrderDetails          = lazy(() => import('../pages/user/course/OrderDetails'));
const Result                = lazy(() => import('../pages/user/course/CourseWatch/Result'));
const Resultvideo           = lazy(() => import('../pages/user/course/CourseWatch/Resultvideo'));
const UserLiveSession         = lazy(() => import('../pages/user/livesession/LiveSession'));
const AssignmentQuestions   = lazy(() => import('../pages/user/livesession/AssignmentQuestions'));
const AssessmentQuestions   = lazy(() => import('../pages/user/livesession/AssessmentQuestions'));
const AssessmentQuiz        = lazy(() => import('../pages/user/livesession/AssessmentQuiz'));
const AssignmentQuizResult  = lazy(() => import('../pages/user/livesession/AssignmentQuizResult'));
const UserNotifications     = lazy(() => import('../pages/user/notification/Notifications'));
const NotificationDetails   = lazy(() => import('../pages/user/notification/NotificationDetails'));
const Settings              = lazy(() => import('../pages/user/settings/Settings'));
const AllLiveSession          = lazy(() => import('../pages/user/livesession/AllLiveSession'));
const ZoomMeeting           = lazy(() => import('../components/zoom/ZoomMeeting'));
const Feed                  = lazy(() => import('../pages/user/feed/Feed'));
const MyFeed                = lazy(() => import('../pages/user/feed/MyFeed'));
const UserBillingDashboard  = lazy(() => import('../pages/user/billing/UserBillingDashboard'));
const SubscriptionPlans     = lazy(() => import('../pages/user/billing/SubscriptionPlans'));
const Checkout              = lazy(() => import('../pages/user/billing/Checkout'));

const Fallback = () => (
  <div className="flex items-center justify-center min-h-[60vh]">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const SearchRedirect = () => {
  const location = useLocation();
  return <Navigate to={`/user/all-courses${location.search}`} replace />;
};

function UserRoutes() {
  return (
    <>
      <Suspense fallback={<Fallback />}>
        <Routes>
          <Route path="assessmentQuiz/:encodedAssessmentId" element={<AssessmentQuiz />} />
          <Route path="zoom-meeting" element={<ZoomMeeting />} />

          <Route path="" element={<UserLayout />}>
            <Route path="dashboard" element={<UserDashboard />} />
            <Route path="accounts" element={<UserAccounts />} />
            <Route path="profile" element={<Navigate to="/user/accounts" replace />} />

            <Route path="live-sessions" element={<AllLiveSession />} />
            <Route path="live-sessions/liveSessionDetails/:encodedLiveSessionID" element={<UserLiveSession />} />
            <Route path="assignmentsQuestions/:encodedAssignmentId" element={<AssignmentQuestions />} />
            <Route path="assessmentQuestions" element={<AssessmentQuestions />} />
            <Route path="assignmentQuizResult" element={<AssignmentQuizResult />} />

            <Route path="search" element={<SearchRedirect />} />

            <Route path="courses" element={<UserCourses />} />
            <Route path="my-courses" element={<MyCourses />} />
            <Route path="all-courses" element={<AllCourses />} />
            <Route path="courses/courseDetails/:encodedId" element={<CourseDetails />} />
            <Route path="my-courses/WatchCourse/:slug" element={<CourseWatch />} />
            <Route path="courses/orderDetails" element={<OrderDetails />} />
            <Route path="courses/result" element={<Result />} />
            <Route path="resultvideo" element={<Resultvideo />} />

            <Route path="certificates" element={<Navigate to="/user/accounts?tab=certificates" replace />} />

            <Route path="notifications" element={<UserNotifications />} />
            <Route path="notifications/notificationDetails" element={<NotificationDetails />} />

            <Route path="settings" element={<Settings />} />

            <Route path="help" element={<Navigate to="/user/settings?tab=help&section=faq" replace />} />
            <Route path="help/faq" element={<Navigate to="/user/settings?tab=help&section=faq" replace />} />
            <Route path="help/ticket" element={<Navigate to="/user/settings?tab=help&section=ticket" replace />} />

            <Route path="feed" element={<Feed />} />
            <Route path="my-feed" element={<MyFeed />} />

            <Route path="billing" element={<UserBillingDashboard />} />
            <Route path="billing/plans" element={<SubscriptionPlans />} />
            <Route path="billing/checkout" element={<Checkout />} />
          </Route>
        </Routes>
      </Suspense>
      <ToastContainer />
    </>
  );
}

export default UserRoutes;
